import { useContext } from "react";
import { Navbar, Nav, Container, NavDropdown, Badge } from "react-bootstrap";
import UserContext from "../context/UserContext";
import { NavLink } from "react-router-dom";

function AppNavbar() {
  const { user } = useContext(UserContext);

  // Dynamic theme based on user role
  const getNavbarTheme = () => {
    if (user?.isAdmin) {
      return {
        background: "linear-gradient(135deg, #6f42c1 0%, #495057 100%)",
        shadowColor: "rgba(111, 66, 193, 0.3)",
        patternId: "adminNavPattern",
        patternColor: "%236f42c1",
      };
    }
    return {
      background: "linear-gradient(135deg, #28a745 0%, #20c997 100%)",
      shadowColor: "rgba(40, 167, 69, 0.3)",
      patternId: "navPattern",
      patternColor: "%2328a745",
    };
  };

  const theme = getNavbarTheme();

  return (
    <div className="navbar-wrapper">
      <Navbar
        expand="lg"
        className="custom-navbar py-3"
        style={{
          background: theme.background,
          boxShadow: `0 4px 20px ${theme.shadowColor}`,
          backdropFilter: "blur(10px)",
        }}
        variant="dark"
      >
        <Container>
          <Navbar.Brand
            as={NavLink}
            to="/"
            className="fw-bold d-flex align-items-center"
            style={{ fontSize: "1.5rem" }}
          >
            <div
              className="me-2 d-flex align-items-center justify-content-center brand-icon"
              style={{
                background: "rgba(255, 255, 255, 0.2)",
                borderRadius: "12px",
                width: "40px",
                height: "40px",
                backdropFilter: "blur(10px)",
              }}
            >
              <i
                className={`fas ${
                  user?.isAdmin ? "fa-crown" : "fa-store"
                } text-white`}
              ></i>
            </div>
            <span className="text-white">
              {user?.isAdmin ? "FreshMart Admin" : "FreshMart"}
            </span>
          </Navbar.Brand>
          <Navbar.Toggle
            aria-controls="basic-navbar-nav"
            className="border-0"
            style={{ background: "rgba(255, 255, 255, 0.1)" }}
          />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto">
              <Nav.Link
                as={NavLink}
                to="/products"
                className="fw-semibold mx-2 nav-link-custom"
              >
                <i className="fas fa-shopping-bag me-2"></i>
                Products
              </Nav.Link>

              {user?.isAdmin === false && (
                <Nav.Link
                  as={NavLink}
                  to="/cart"
                  className="fw-semibold mx-2 nav-link-custom"
                >
                  <i className="fas fa-shopping-cart me-2"></i>
                  Cart
                </Nav.Link>
              )}
              {user?.isAdmin && (
                <Nav.Link
                  as={NavLink}
                  to="/admin/users"
                  className="fw-semibold mx-2 nav-link-custom"
                >
                  <i className="fas fa-users me-2"></i>
                  Users
                </Nav.Link>
              )}

              {user && (
                <Nav.Link
                  as={NavLink}
                  to="/orders"
                  className="fw-semibold mx-2 nav-link-custom"
                >
                  <i className="fas fa-receipt me-2"></i>
                  Orders
                </Nav.Link>
              )}
            </Nav>

            {/* User Section */}
            <Nav className="ms-auto">
              {user ? (
                <NavDropdown
                  title={
                    <span className="d-flex align-items-center text-white">
                      <div
                        className="me-2 user-avatar"
                        style={{
                          background: user?.isAdmin
                            ? "linear-gradient(135deg, rgba(255, 255, 255, 0.3), rgba(255, 255, 255, 0.1))"
                            : "rgba(255, 255, 255, 0.2)",
                          borderRadius: "50%",
                          width: "32px",
                          height: "32px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          border: user?.isAdmin
                            ? "2px solid rgba(255, 255, 255, 0.4)"
                            : "none",
                        }}
                      >
                        <i
                          className={`fas ${
                            user?.isAdmin ? "fa-user-shield" : "fa-user"
                          }`}
                          style={{ fontSize: "0.9rem" }}
                        ></i>
                      </div>
                      <span className="fw-semibold">
                        {user?.firstName || "Profile"}
                      </span>
                      {user?.isAdmin && (
                        <Badge
                          className="admin-user-badge ms-2"
                          style={{
                            fontSize: "0.7rem",
                            background: "rgba(255, 255, 255, 0.25)",
                            color: "white",
                            border: "1px solid rgba(255, 255, 255, 0.3)",
                            animation: "glow 2s ease-in-out infinite alternate",
                          }}
                        >
                          <i className="fas fa-star me-1"></i>
                          Admin
                        </Badge>
                      )}
                    </span>
                  }
                  id="profile-dropdown"
                  className={`profile-dropdown ${
                    user?.isAdmin ? "admin-dropdown" : ""
                  }`}
                >
                  <NavDropdown.Item
                    as={NavLink}
                    to="/profile"
                    className="d-flex align-items-center"
                  >
                    <i className="fas fa-user-circle me-2 text-primary"></i>
                    View Profile
                  </NavDropdown.Item>

                  <NavDropdown.Divider />
                  <NavDropdown.Item
                    as={NavLink}
                    to="/logout"
                    className="d-flex align-items-center text-danger"
                  >
                    <i className="fas fa-sign-out-alt me-2"></i>
                    Logout
                  </NavDropdown.Item>
                </NavDropdown>
              ) : (
                <div className="d-flex gap-2">
                  <Nav.Link
                    as={NavLink}
                    to="/login"
                    className="btn btn-outline-light fw-semibold px-3 py-2 auth-btn"
                    style={{
                      borderRadius: "25px",
                      transition: "all 0.3s ease",
                    }}
                  >
                    <i className="fas fa-sign-in-alt me-2"></i>
                    Login
                  </Nav.Link>
                  <Nav.Link
                    as={NavLink}
                    to="/register"
                    className="btn btn-light fw-semibold px-3 py-2 auth-btn register-btn"
                    style={{
                      borderRadius: "25px",
                      transition: "all 0.3s ease",
                      color: user?.isAdmin ? "#6f42c1" : "#28a745",
                    }}
                  >
                    <i className="fas fa-user-plus me-2"></i>
                    Register
                  </Nav.Link>
                </div>
              )}
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      {/* Custom Styles */}
      <style jsx>{`
        .navbar-wrapper {
          position: sticky;
          top: 0;
          z-index: 1030;
        }

        .custom-navbar {
          position: relative;
        }

        .custom-navbar::before {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="${theme.patternId}" width="30" height="30" patternUnits="userSpaceOnUse"><circle cx="15" cy="15" r="1" fill="white" opacity="0.1"/><circle cx="5" cy="25" r="0.5" fill="white" opacity="0.15"/><circle cx="25" cy="5" r="0.5" fill="white" opacity="0.15"/></pattern></defs><rect width="100" height="100" fill="url(%23${theme.patternId})"/></svg>');
          pointer-events: none;
          opacity: 0.3;
        }

        .brand-icon {
          transition: all 0.3s ease;
        }

        .brand-icon:hover {
          transform: scale(1.1) rotate(10deg);
          background: rgba(255, 255, 255, 0.3) !important;
        }

        .admin-indicator {
          animation: pulse-glow 2s ease-in-out infinite alternate;
        }

        .admin-badge {
          backdrop-filter: blur(10px);
          transition: all 0.3s ease;
        }

        .admin-badge:hover {
          transform: scale(1.05);
          background: rgba(255, 255, 255, 0.3) !important;
        }

        .user-avatar {
          transition: all 0.3s ease;
        }

        .user-avatar:hover {
          transform: scale(1.1);
        }

        .admin-user-badge {
          backdrop-filter: blur(10px);
        }

        @keyframes glow {
          from {
            box-shadow: 0 0 5px rgba(255, 255, 255, 0.3);
          }
          to {
            box-shadow: 0 0 15px rgba(255, 255, 255, 0.6);
          }
        }

        @keyframes pulse-glow {
          from {
            opacity: 0.8;
          }
          to {
            opacity: 1;
          }
        }

        .nav-link-custom {
          padding: 8px 16px !important;
          border-radius: 20px !important;
          transition: all 0.3s ease !important;
          color: rgba(255, 255, 255, 0.9) !important;
        }

        .nav-link-custom:hover {
          background: rgba(255, 255, 255, 0.2) !important;
          color: white !important;
          transform: translateY(-1px);
        }

        .nav-link-custom.active {
          background: rgba(255, 255, 255, 0.3) !important;
          color: white !important;
        }

        .profile-dropdown .dropdown-toggle {
          background: rgba(255, 255, 255, 0.1) !important;
          border: none !important;
          border-radius: 25px !important;
          padding: 8px 16px !important;
          transition: all 0.3s ease !important;
        }

        .profile-dropdown .dropdown-toggle:hover {
          background: rgba(255, 255, 255, 0.2) !important;
          transform: translateY(-1px);
        }

        .admin-dropdown .dropdown-toggle {
          background: linear-gradient(
            135deg,
            rgba(255, 255, 255, 0.15),
            rgba(255, 255, 255, 0.05)
          ) !important;
          border: 1px solid rgba(255, 255, 255, 0.2) !important;
        }

        .admin-dropdown .dropdown-toggle:hover {
          background: linear-gradient(
            135deg,
            rgba(255, 255, 255, 0.25),
            rgba(255, 255, 255, 0.15)
          ) !important;
          border-color: rgba(255, 255, 255, 0.4) !important;
          box-shadow: 0 4px 15px rgba(111, 66, 193, 0.3);
        }

        .admin-dropdown .dropdown-menu {
          background: linear-gradient(
            135deg,
            #ffffff 0%,
            #f8f9fa 100%
          ) !important;
          border: 2px solid rgba(111, 66, 193, 0.2) !important;
        }

        .admin-dropdown .dropdown-item:hover {
          background: linear-gradient(
            135deg,
            #e8e6ff 0%,
            #f0efff 100%
          ) !important;
          color: #6f42c1 !important;
        }

        .profile-dropdown .dropdown-menu {
          border: none !important;
          border-radius: 15px !important;
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15) !important;
          padding: 10px !important;
          margin-top: 10px !important;
        }

        .profile-dropdown .dropdown-item {
          border-radius: 8px !important;
          padding: 10px 15px !important;
          transition: all 0.2s ease !important;
        }

        .profile-dropdown .dropdown-item:hover {
          background: #f8f9fa !important;
          transform: translateX(5px);
        }

        .btn-outline-light:hover {
          background: white !important;
          color: ${user?.isAdmin ? "#6f42c1" : "#28a745"} !important;
          border-color: white !important;
          transform: translateY(-2px);
          box-shadow: 0 4px 15px rgba(255, 255, 255, 0.3);
        }

        .btn-light:hover {
          background: #f8f9fa !important;
          transform: translateY(-2px);
          box-shadow: 0 4px 15px rgba(255, 255, 255, 0.3);
        }

        .register-btn {
          color: ${user?.isAdmin ? "#6f42c1" : "#28a745"} !important;
        }

        .register-btn:hover {
          color: ${user?.isAdmin ? "#6f42c1" : "#28a745"} !important;
        }

        /* Enhanced admin theme styles */
        ${user?.isAdmin
          ? `
          .nav-link-custom:hover {
            background: rgba(255, 255, 255, 0.25) !important;
            box-shadow: 0 2px 8px rgba(111, 66, 193, 0.2);
          }

          .nav-link-custom.active {
            background: rgba(255, 255, 255, 0.35) !important;
            box-shadow: 0 2px 8px rgba(111, 66, 193, 0.3);
          }
        `
          : ""}

        @media (max-width: 991px) {
          .navbar-nav .nav-link {
            text-align: center;
            margin: 5px 0;
          }

          .d-flex.gap-2 {
            flex-direction: column;
            gap: 10px !important;
          }
        }
      `}</style>
    </div>
  );
}

export default AppNavbar;
